import { useEffect } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc)
dayjs.extend(timezone);

const TimeSeriesChart = ({data, yAxisUnits='', seriesName='', seriesColor='#40affe'}) => {
  
  useEffect (() => {
    Highcharts.setOptions({
      time: {
        timezone: dayjs.tz.guess(),  
      }
    });
  },[])
  
  const options = {
    chart: {
      type: 'spline',
      height: 250,
      marginBottom: 55,
    },
    title: {
      text: '',
    },
    credits: {
        enabled: false,
    },
    exporting: {
        enabled: false,
    },
    legend: {
        enabled: true,
        margin: 50,
        verticalAlign: 'bottom',
        align: "left",
        padding: 0,
        symbolWidth: 20,
        y: 16,
        itemStyle: {
            fontSize: '12px',    
        },    
    },
    xAxis: {
        type: "datetime",
        tickWidth: 1,
        tickColor: "#e6e6e6",
        lineWidth: 0,
        labels: {
          formatter: function () {
            return Highcharts.dateFormat('%H:%M:%S', this.value);
          },
          fontSize: '10px',    
        },
    },
    yAxis: {
        title: "",
        labels: {
            formatter: function() {
              return this.value % 1 !== 0 ? this.value.toFixed(2) + `${yAxisUnits}`
               : this.value + `${yAxisUnits}` ;
            },
            fontSize: '10px',    
        },
    },
    series: [
      {
        name: seriesName,
        data: data,
        color: seriesColor,
        marker: {
          enabled: false,
        },
      },
    ],
    tooltip: {
      formatter: function () {
        const formattedTime = Highcharts.dateFormat('%H:%M:%S', this.x);
        return `<div style="text-align: center">${formattedTime}<br>
        <span style="color:${seriesColor}"><b>•</b></span>
        <span><b>${seriesName}: ${this.y}</b></span></div>`;
      },
    },
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default TimeSeriesChart;
